import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { TransmissionStatusInformation } from '../../models/transmission-status-information.model';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { VehicleConfigService } from 'src/app/vehicles/services/vehicle-config.service';
@Component({
  selector: 'app-button-toggle-container',
  templateUrl: './button-toggle-container.component.html',
  styleUrls: ['./button-toggle-container.component.scss'],
})
export class ButtonToggleContainerComponent implements OnInit, OnDestroy {
  @Input() transmissionStatusInformation: TransmissionStatusInformation[] = [];
  @Output() onClick = new EventEmitter<{
    transmissionStatusId: number;
    isActive: boolean;
  }>();

  private onDestroy$ = new Subject<boolean>();
  private selectButtonSubject$ = new Subject<{
    transmissionStatusId: number;
    isActive: boolean;
  }>();

  /* Quizas deba manejarlo en el padre o no ya se vera todavia */
  isActive = [false, false, false, false, false, false, false];

  constructor(
    public vehicleConfigService : VehicleConfigService
  ){
  }
  

  ngOnInit(): void {
    this.setupSelectButtonSubscription();
  }

  private setupSelectButtonSubscription(): void {
    this.selectButtonSubject$
      .pipe(
        takeUntil(this.onDestroy$),
        debounceTime(300),
        distinctUntilChanged((prev, current) => {
          return (
            prev.transmissionStatusId === current.transmissionStatusId &&
            prev.isActive === current.isActive
          );
        })
      )
      .subscribe(({ transmissionStatusId, isActive }) => {
        this.onClick.emit({
          transmissionStatusId: transmissionStatusId,
          isActive: isActive,
        });
      });
  }

  onSelectButton(transmissionStatusId: number) {
    const selectedStatus = this.transmissionStatusInformation.find(
      (info) => info.transmissionStatusId === transmissionStatusId
    );
    if (selectedStatus) {
      this.isActive[transmissionStatusId] =
        !this.isActive[transmissionStatusId];
      this.selectButtonSubject$.next({
        transmissionStatusId: selectedStatus.transmissionStatusId,
        isActive: this.isActive[transmissionStatusId],
      });
    }
    this.transmissionStatusInformation.forEach((info) => {
      if (info.transmissionStatusId !== transmissionStatusId) {
        this.isActive[info.transmissionStatusId] = false;
      }
    });
  }

  ngOnDestroy(): void {
    this.onDestroy$.next(true);
    this.onDestroy$.complete();
  }
}
